import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

const instance = axios.create({
    baseURL: BASE_URL,
    withCredentials: true
});

// Security headers
instance.defaults.headers.common['Referrer-Policy'] = 'origin';
instance.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
instance.defaults.headers.common['Content-Security-Policy'] = 'default-src self';
instance.defaults.headers.common['Strict-Transport-Security'] = 'max-age=63072000; includeSubDomains; preload';

export default instance;